import { logComponentError } from '@ms/yammer-diagnostics-state';
import Null from '@ms/yammer-libs-null';
import { reportError } from '@ms/yammer-telemetry';
import type { ReactNode } from 'react';
import React, { PureComponent } from 'react';

import type { ErrorBoundaryName, ErrorComponent } from './types';

export interface ErrorBoundaryProps {
  readonly children: ReactNode;
  readonly name: ErrorBoundaryName;
  readonly ErrorComponent?: ErrorComponent;
}

export interface ErrorBoundaryState {
  readonly error: unknown;
}

export default class ErrorBoundary extends PureComponent<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    error: undefined,
  };

  public static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  public componentDidCatch(error: unknown) {
    logComponentError(this.props.name, error);

    reportError({
      error,
      eventProperties: {
        errorBoundaryName: this.props.name,
        errorCode: 'ErrorBoundary',
      },
    });
  }

  public render() {
    const { ErrorComponent, children } = this.props;

    const ErrorComponentOrDefault = ErrorComponent || Null;

    return this.state.error ? (
      <div className="qaErrorBoundary">
        <ErrorComponentOrDefault error={this.state.error} />
      </div>
    ) : (
      children
    );
  }
}
